import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import determineCartReviewsVersion, { CART_REVIEWS_V2, PARTNER_CART_REVIEWS_V2 } from './determine-cart-reviews-version';
import getFetchGlobalConfigOptions from "../../../../global-config/get-options";
import getFetchCartOptions from "../fetch/get-options";

/**
 * updateCartReviewsTotals
 *
 * @param {object} params - named parameters
 * @param {object} params.queryClient - the query client
 * @returns {Promise<undefined>} resolves when update is complete
 *
 * @description this function is used to update the totals of the cart reviews response
 * based on the items in 'carts'. It lazy loads only the required update function based on
 * the global store configuration and feature flags.
 */
var updateCartReviewsTotals = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var queryClient, _ref3, _ref3$items, items, summaryTotal, summarySubtotal, summaryDiscountTotal, _iterator, _step, cartItem, priceInfo, total, subtotal, discount, globalConfig, isGlobalStoreCountry, cartReviewsPath, _yield$import, updateCartReviewsV2, _yield$import2, getQueryKey, _yield$import3, _updateCartReviewsV, _yield$import4, _getQueryKey, _yield$import5, updatePartnerCartReviewsV1;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          queryClient = _ref.queryClient;
          _ref3 = queryClient.getQueryData(getFetchCartOptions({
            queryClient: queryClient
          }).queryKey) || {}, _ref3$items = _ref3.items, items = _ref3$items === void 0 ? [] : _ref3$items; // Calculate totals from cart items
          summaryTotal = 0;
          summarySubtotal = 0;
          summaryDiscountTotal = 0;
          _iterator = _createForOfIteratorHelper(items);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              cartItem = _step.value;
              priceInfo = cartItem.priceInfo;
              total = priceInfo.total, subtotal = priceInfo.subtotal, discount = priceInfo.discount;
              summaryTotal += total;
              summarySubtotal += subtotal;
              summaryDiscountTotal += discount;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          globalConfig = queryClient.getQueryData(getFetchGlobalConfigOptions().queryKey);
          isGlobalStoreCountry = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.isGlobalStoreCountry; // Determine which version of cart reviews to use
          cartReviewsPath = determineCartReviewsVersion({
            isGlobalStoreCountry: isGlobalStoreCountry
          });
          if (!(cartReviewsPath === CART_REVIEWS_V2)) {
            _context.next = 3;
            break;
          }
          _context.next = 1;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./update-cart-reviews-v2'));
          });
        case 1:
          _yield$import = _context.sent;
          updateCartReviewsV2 = _yield$import["default"];
          _context.next = 2;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../../../cart_reviews/v2/get-query-key"));
          });
        case 2:
          _yield$import2 = _context.sent;
          getQueryKey = _yield$import2["default"];
          updateCartReviewsV2({
            queryClient: queryClient,
            getQueryKey: getQueryKey,
            summaryTotal: summaryTotal,
            summarySubtotal: summarySubtotal,
            summaryDiscountTotal: summaryDiscountTotal
          });
          _context.next = 8;
          break;
        case 3:
          if (!(cartReviewsPath === PARTNER_CART_REVIEWS_V2)) {
            _context.next = 6;
            break;
          }
          _context.next = 4;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./update-cart-reviews-v2'));
          });
        case 4:
          _yield$import3 = _context.sent;
          _updateCartReviewsV = _yield$import3["default"];
          _context.next = 5;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require("../../../partner_cart_reviews/v2/get-query-key"));
          });
        case 5:
          _yield$import4 = _context.sent;
          _getQueryKey = _yield$import4["default"];
          _updateCartReviewsV({
            queryClient: queryClient,
            getQueryKey: _getQueryKey,
            summaryTotal: summaryTotal,
            summarySubtotal: summarySubtotal,
            summaryDiscountTotal: summaryDiscountTotal
          });
          _context.next = 8;
          break;
        case 6:
          _context.next = 7;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('./update-partner-cart-reviews-v1'));
          });
        case 7:
          _yield$import5 = _context.sent;
          updatePartnerCartReviewsV1 = _yield$import5["default"];
          updatePartnerCartReviewsV1({
            queryClient: queryClient,
            summaryTotal: summaryTotal,
            summarySubtotal: summarySubtotal
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function updateCartReviewsTotals(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default updateCartReviewsTotals;